module.exports = __webpack_public_path__ + "static/media/myrx.656b8d1e.png";